import { createSlice } from '@reduxjs/toolkit';
const initialState = { requests: [] };
const slice = createSlice({
    name: 'loading',
    initialState,
    reducers: {
        addLoadingItem: (state, action) => {
            // console.info('%c[LOADING]', 'color:green;', action.payload);
            state.requests.push(action.payload);
        },
        clearLoadingItems: (state) => {
            state.requests.pop();
        },
    },
});
export const { addLoadingItem, clearLoadingItems } = slice.actions;
export default slice;
